/**
 * @file Share Modal
 */

import { gsap } from 'gsap';

/**
 * Share Modal component
 */
const vShareModal = () => {
	const shareModal = document.querySelector('.v-share-modal');

	if (!shareModal) {
		return;
	}

	const triggers = document.querySelectorAll('.v-header__share-trigger');

	if (!triggers.length) {
		return;
	}

	const overlay = shareModal.querySelector('.v-share-modal__overlay');
	const content = shareModal.querySelector('.v-share-modal__content');
	const close   = shareModal.querySelector('.v-share-modal__close');

	[...triggers].forEach((trigger) => {
		trigger.addEventListener('click', () => {
			shareModal.style.display = 'block';
			gsap.timeline({
				defaults: {
					ease:      'sine.out',
					overwrite: true,
				},
				onComplete() {
					shareModal.classList.add('v-share-modal--active');
					shareModal.removeAttribute('style');
					overlay.removeAttribute('style');
					content.removeAttribute('style');
					close.removeAttribute('style');
				},
			})
				.to(overlay, {
					opacity:  0.75,
					duration: 0.3,
				})
				.to(content, {
					y:        0,
					opacity:  1,
					duration: 0.4,
				}, '>-.1')
				.to(close, {
					opacity:  1,
					duration: 0.3,
				}, '>-.1');
		});
	});

	close.addEventListener('click', () => {
		gsap.timeline({
			defaults: {
				ease:      'sine.out',
				overwrite: true,
			},
			onComplete() {
				shareModal.classList.remove('v-share-modal--active');
				shareModal.removeAttribute('style');
				overlay.removeAttribute('style');
				content.removeAttribute('style');
				close.removeAttribute('style');
			},
		})
			.to(close, {
				opacity:  0,
				duration: 0.3,
			})
			.to(content, {
				y:        20,
				opacity:  0,
				duration: 0.4,
			}, '>-.1')
			.to(overlay, {
				opacity:  0,
				duration: 0.3,
			}, '>-.1');
	});
};

export default vShareModal;
